import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  scrollContainer: {
    // overflowX:  '',
    margin: '0px 20px',
  },
}));
